import { gql } from 'src/generated/gql';

export const UPDATE_SETTINGS = gql(`
  mutation UpdatePopInQueueSettings($settings: [staff_QueueSettingInput!]!) {
    staff_saveClinicQueueSettings(settings: $settings)
  }
`);
